import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ADateRangeSliderComponent } from './components/a-date-range-slider/a-date-range-slider.component';
import { DateSliderComponent } from './components/date-slider/date-slider.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { ADateFnsAdapterModule } from '../a-date-fns-adapter';
import { AMatCalendarHeaderComponent } from './components/a-mat-calendar-header/a-mat-calendar-header.component';
import { ADateRangeSettingComponent } from './components/a-date-range-setting/a-date-range-setting.component';
import { AdDropdownListModule } from '../ad-dropdown-list';
import { AdButtonModule } from '../ad-button/ad-button.module';
import { ADateRangeInputComponent } from './components/a-date-range-input/a-date-range-input.component';
import { AMatCalendarYearComponent } from './components/a-mat-calendar-year/a-mat-calendar-year.component';
import { AMatCalendarMonthComponent } from './components/a-mat-calendar-month/a-mat-calendar-month.component';


@NgModule({
  declarations: [ADateRangeSliderComponent, DateSliderComponent, AMatCalendarHeaderComponent, ADateRangeSettingComponent, ADateRangeInputComponent, AMatCalendarYearComponent, AMatCalendarMonthComponent],
  imports: [
    CommonModule,
    FormsModule,
    AdDropdownListModule,
    MatDatepickerModule,
    OverlayModule,
    ADateFnsAdapterModule,
    AdButtonModule
  ],
  providers: [],
  exports: [ADateRangeSliderComponent, DateSliderComponent, ADateRangeSettingComponent, ADateRangeInputComponent]
})
export class ADateRangeSliderModule { }
